<template>
  <svg
    class="bag-icon"
    viewBox="0 0 16 16"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g
      v-if="!active"
      id="icons/bag/empty"
      stroke="none"
      stroke-width="1"
      fill="none"
      fill-rule="evenodd"
    >
      <path
        d="M11.0001,3.9995 L14,3.9995 L14,15.9995 L2,15.9995 L2,3.9995 L5.0001,3.9995 L5.0001,1.25 L6.25,2.72004641e-15 L9.75,0.0002 L11.0001,1.25 L11.0001,3.9995 Z M9.7501,3.9995 L9.7501,1.2492 L6.2501,1.2492 L6.2501,3.9995 L9.7501,3.9995 Z M5.0001,5.25 L3.25,5.25 L3.25,14.75 L12.75,14.75 L12.75,5.25 L11.0001,5.25 L11.0001,6.9992 L9.7501,6.9992 L9.7501,5.25 L6.2501,5.25 L6.2501,6.9992 L5.0001,6.9992 L5.0001,5.25 Z"
        id="bag"
        :fill="color"
      />
    </g>
    <g v-else>
      <path
        d="M 11 4 L 14 4 L 14 16 L 2 16 L 2 4 L 5 4 L 5 1.25 L 6.25 0 L 9.75 0 L 11 1.25 L 11 4 Z M 9.75 4 L 9.75 1.249 L 6.25 1.249 L 6.25 4 L 9.75 4 Z"
        id="bag"
        :fill="color"
      />
      <text
        class="bag-count font-responsive-smallest -small-caps"
        alignment-baseline="middle"
        dominant-baseline="middle"
        text-anchor="middle"
        x="50%"
        :y="`${textpos}%`"
        fill="#fcfcfc"
      >
        {{ currentText }}
      </text>
    </g>
  </svg>
</template>

<script>
export default {
  props: {
    count: Number,
    active: Boolean,
    color: {
      type: String
    },
    size: {
      type: Number,
      default: 16
    }
  },
  data () {
    return {
      firstload: true,
      textYLock: 65,
      textpos: 65,
      currentText: this.count,
      animate: null
    };
  },
  watch: {
    count (newval, oldval) {
      let dir = 'out';
      if (!(this.firstload && oldval === 0) && newval !== oldval) {
        clearInterval(this.animate);
        this.animate = setInterval(() => {
          this.textpos += 10;
          if (this.textpos > 120) {
            this.currentText = newval;
            this.textpos = 0;
            dir = 'in';
          }
          if (dir === 'in' && this.textpos > this.textYLock) {
            this.textpos = this.textYLock;
            clearInterval(this.animate);
          }
        }, 5);
      }
      if (this.firstload) {
        this.currentText = newval;
        this.firstload = false;
      }
    }
  }
};
</script>
<style lang="scss">
@import "@/scss/defaults.scss";
.bag-icon {
    width: rem(16px);
    height:rem(16px);
  .bag-count {
    .-black-theme & {
      fill: $black;
    }
  }
}
</style>
